module.exports = "/packs/images/sprites/breadcrumbs~417902933f0735013d4b8ce4811ba6d7.png";